import React from 'react';
import { Link } from 'react-router-dom';

import { isExternalLink, isInternalLink } from '../../utils/publicLinks';

function PublicActionLink({ link, className, children }) {
  if (!link?.label || !link?.href) {
    return null;
  }

  const content = children || link.label;

  if (isInternalLink(link)) {
    return (
      <Link to={link.href} className={className}>
        {content}
      </Link>
    );
  }

  return (
    <a
      href={link.href}
      className={className}
      target={isExternalLink(link) ? '_blank' : undefined}
      rel={isExternalLink(link) ? 'noopener noreferrer' : undefined}
    >
      {content}
    </a>
  );
}

export default PublicActionLink;

